module.exports = require('./helpers/bundle-url').getBundleURL('ii3gA') + "logo-dark.ba5147f0.svg";